module.exports = "<div>\n\t<video style=\"width: 100%; height: 100%\"\n\t\tcontrols\n\t   \tautoplay\n\t   \tv-on:ended=\"onEnd\">\n\t\t<source v-bind:src=\"url\" type=\"video/mp4\" />\n\t</video>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/fullscreen/fullscreen.html
// module id = 210
// module chunks = 0